import { reduxAPI } from "../redux/reduxAPI";
import {
  getQueryStringWithCreator,
  postQueryBodyWithCreator,
} from "../utils/reduxHelper";
/**
 * FTUX Service for handling First-Time User Experience API calls
 * Based on the backend FTUX API endpoints
 */

// FTUX API endpoints
const FTUX_ENDPOINTS = {
  MARK_FEATURE_VISITED: "c/markFeatureVisited",
  GET_FTUX_HOME_TAKEOVER_FLOW: "c/getFTUXHomeTakeoverFlow",
  GET_FTUX_DETAILS: "c/getFTUXDetails",
};

// Enhanced FTUX API slice
export const ftuxAPI = reduxAPI.injectEndpoints({
  endpoints: (builder) => ({
    getFTUXHomeTakeoverFlow: builder.query({
      query: () => ({
        url: getQueryStringWithCreator(
          FTUX_ENDPOINTS.GET_FTUX_HOME_TAKEOVER_FLOW
        ),
        method: "GET",
      }),
      providesTags: ["FTUX"],
    }),
    getFTUXDetails: builder.query({
      query: (feature) =>
        `${getQueryStringWithCreator(
          FTUX_ENDPOINTS.GET_FTUX_DETAILS
        )}&feature=${feature}`,
      providesTags: ["FTUX"],
    }),
    postMarkFeatureVisited: builder.mutation({
      query: (body) => ({
        url: FTUX_ENDPOINTS.MARK_FEATURE_VISITED,
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
      invalidatesTags: ["QuickAccessIndicators", "FTUX", "COCEvent"],
    }),
  }),
});

// Export hooks for use in components
export const {
  useGetFTUXHomeTakeoverFlowQuery,
  useGetFTUXDetailsQuery,
  usePostMarkFeatureVisitedMutation,
} = ftuxAPI;
